import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const DELETE_MFA_METHOD_MUTATION = gql`
  mutation DeleteMfaMethodMutation($methodId: ID!) {
    deleteMfaMethod(methodId: $methodId) {
      removed
      errorCode
    }
  }
`;

export default function useDeleteMfaMethod() {
  const [deleteMfaMethodMutation, { loading, error }] = useMutation(DELETE_MFA_METHOD_MUTATION, {
    noThrow: true,
  });

  const deleteMfaMethod = useCallback(
    async (methodId) => {
      const response = await deleteMfaMethodMutation({
        variables: { methodId },
      });

      return response?.data?.deleteMfaMethod || null;
    },
    [deleteMfaMethodMutation],
  );

  useError(error);

  return {
    deleteMfaMethod,
    loading,
  };
}
